export default {
  LOW_BUDGET: 'lowBudgetAlerts',
  NEWSLETTER: 'newsletter',
  DAILY_STATS: 'dailyStats',
  KEYWORD_ALERTS: 'keywordsAlerts',
  CAMPAIGNS_STOP_ALERTS: 'campaignsStopAlerts',
};
